<template>
  <div>
    <h5>Informações Gerais</h5>

    <table>
      <tbody>
        <table-row
          label="Título"
          :value="campaignData.title"
        />
        <table-row
          label="Assunto"
          :value="campaignData.subject_line"
        />
        <table-row
          label="Remetente"
          :value="`${campaignData.from_name} (${campaignData.reply_to})`"
        />
        <table-row
          label="Texto de Pré-Visualização"
          :value="campaignData.preview_text"
        />
        <table-row
          label="Data & Hora de Criação"
          :value="formatStringDate(campaignData.created_at)"
        />
        <table-row
          label="Data & Hora de Atualização"
          :value="formatStringDate(campaignData.updated_at)"
        />
        <table-row
          label="Segmentos da Campanha"
          :value="campaignSegments"
        />
      </tbody>
    </table>

    <br/>

    <h5>Estatísticas da Campanha</h5>

    <table>
      <tbody>
        <table-row
          label="Data & Hora do Envio do Teste"
          :value="handleSentData(campaignData.test_sent_at)"
        />
        <table-row
          label="Data & Hora do Envio da Campanha"
          :value="handleSentData(campaignData.sent_at)"
        />
        <table-row
          label="Status"
          :value="handleCampaignStatus(campaignData.mailchimp_infos.status)"
        />
        <table-row
          label="E-mails Enviados"
          :value="campaignData.mailchimp_infos.emails_sent"
        />
        <table-row
          label="Total de Aberturas"
          :value="campaignData.mailchimp_infos.report_summary.opens"
        />
        <table-row
          label="Total de Aberturas Únicas"
          :value="campaignData.mailchimp_infos.report_summary.unique_opens"
        />
        <table-row
          label="Taxa de Abertura"
          :value="`${handleOpeningRate(campaignData.mailchimp_infos.report_summary.open_rate)}%`"
        />
      </tbody>
    </table>
  </div>
</template>

<script>
import TableRow from './TableRow';
import { formatDate } from '@/utils'
import newsletterCampaignSegmentHttp from '@/http/requests/newsletterCampaignSegment'

export default {
  name: 'infos-campaign-popup',
  props: {
    campaignId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      campaignData: {},
      segments: []
    }
  },
  computed: {
    campaignSegments() {
      if (!this.segments.length) {
        return 'Nenhum segmento atrelado'
      }

      return this.segments.join(", ")
    }
  },
  created() {
    this.campaignData = this.$store.state.newsletterCampaign.campaignInfos
  },
  watch: {
    campaignId: async function(id) {
      if (id !== null) {
        this.$store
          .dispatch("newsletterCampaign/infos", id)
          .then(() => {
            this.campaignData = this.$store.state.newsletterCampaign.campaignInfos

            newsletterCampaignSegmentHttp.campaignSegments(id)
              .then(res => {
                const segments = res.data.data.campaignSegments.categories;
                this.segments = segments.map(segment => segment.name);
              })
              .catch(err => { console.error(err) })
          })
          .catch(err => {
            console.error(err);
          })
      }
    }
  },
  methods: {
    formatStringDate(date) {
      return formatDate(date).full
    },
    handleCampaignStatus(status) {
      const allStatus = {
        sent: 'Enviada',
        sending: 'Enviando à todos assinates',
        draft: 'Não enviada',
      }
      
      
      return allStatus[status]
    },
    handleSentData(sentAt) {
      if (sentAt) {
        return this.formatStringDate(sentAt)
      }

      return ''
    },
    handleOpeningRate(rate) {
      return (rate * 100).toFixed(2)
    },
  },
  components: {
    TableRow
  }
}
</script>

<style scoped>
h5 {
  margin-bottom: 5px;
}
</style>